exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/resolve-url-loader!./~/sass-loader?sourceMap!./src/assets/skins/imm.scss
// module id = 65
// module chunks = 0